import React from "react"
import Positions from "../../../components/position/Positions"
import * as accountActions from "../../../actions/AccountActions"
import { IHierarchyItem } from "../../../models"
interface IProps {
	hierarchyItem: IHierarchyItem
	readonly: boolean
}

const HierarchyPositions: React.SFC<IProps> = (props: IProps) => {
	return (
		<Positions
			readonly={props.readonly}
			hideTableActionBarTitle
			addButtonTop={-110}
			addButtonRight={20}
			positions={props.hierarchyItem.Positions || []}
			usablePositions={[]}
			handleAdd={(position, cb) =>
				accountActions.addHierarchyPosition(props.hierarchyItem.Id, position, cb)
			}
			handleUpdate={(position, cb) =>
				accountActions.updateHierarchyPosition(props.hierarchyItem.Id, position, cb)
			}
			handleDelete={(positions, cb) =>
				accountActions.removeHierarchyPositions(props.hierarchyItem.Id, positions.map(item => item.Id), cb)
			}
		/>
	)
}

export default HierarchyPositions
